import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

interface LoaderState {
    loading: boolean;
}

const initialState: LoaderState = {
    loading: false,
}

export const loaderSlice = createSlice({
    name: 'loader',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
    },
});

export const selectLoading = (state: RootState) => state.loader.loading;

export const { setLoading } = loaderSlice.actions;

export default loaderSlice.reducer;